import { useSelector } from 'react-redux'
import { Element } from '../../../../../common/html/element'
import { Tooltip } from '../../../../../common/tooltip'
import { formatDataByUnit, isPercentFormat } from './helper'

const BaseCell = ({
  val,
  colId,
  rowId,
  isDynamicReport,
  backgroundColor,
  formatCurrency,
}) => {
  const locale = useSelector((state) => state.i18n.locale)

  return (
    <td
      rowSpan={isDynamicReport ? 2 : 1}
      style={{
        backgroundColor,
      }}
    >
      <Tooltip
        tooltipContent="portfolio.finance.MEDIAN_RATIO"
        isI18n={true}
        tooltipContentStyle={{
          backgroundColor: '#1E242E',
          opacity: 1,
          color: '#ECECEC',
        }}
      >
        <Element
          className={`${isDynamicReport ? 'textEnd' : 'textCenter fw600'}`}
        >
          {formatDataByUnit(rowId, colId, val, formatCurrency, locale)}
          {isPercentFormat(val, rowId) ? '%' : ''}
        </Element>
      </Tooltip>
    </td>
  )
}

export default BaseCell
